<template>
  <ReportFactPerson :product="product" :user="profile" v-bind="$attrs" />
</template>

<script>
import { mapState } from 'vuex';
import ReportFactPerson from './ReportFactPerson';

export default {
  props: ['product'],
  components: {
    ReportFactPerson,
  },
  computed: {
    ...mapState('session', ['profile']),
  },
};
</script>
